export default __webpack_public_path__ + "static/hr-garden-page-hero-3e2dc4cd58cb921321ec7762de128268.png";